jQuery(document).ready(function($){
  // Change the Image
    var productImage = $('.slider__slide.is-active img').attr('src');
    jQuery('.product-featured-img img').attr('src', productImage);
  // Change the position
    var barNav = $(".product_sticky_bar_nav");
    var cart = $(".product_sticky_cart");

    // Change their positions
    cart.insertBefore(barNav);

  // Get the elements
    var addCartButtonBar = $('.add_cart_button_bar');
    var productStickyNav = $('.product_sticky_bar_nav');

    // Move the add_cart_button_bar after product_sticky_bar_nav
    productStickyNav.after(addCartButtonBar);
})